import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
	providedIn: 'root'
})

export class PostmethodService {
	public generateToken: any
	isLoading = new Subject<boolean>();
	htheadeer: HttpHeaders = new HttpHeaders()

	constructor(private http: HttpClient, private _router: Router) { }


	public wsPost(RequestModel: any, url: string): Observable<any> {
		let token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : '';
		let headers = new HttpHeaders({
			'Content-Type': 'application/json; charset=utf-8',
			'Authorization': `Bearer ${token}`
		});
		return this.http.post(url, RequestModel, { headers: headers, observe: 'response' }).pipe(
			catchError(this.handleError)
		);
	}

	public wsPut(RequestModel: any, url: string, id: any): Observable<any> {
		let token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : '';
		let headers = new HttpHeaders({
			'Content-Type': 'application/json; charset=utf-8',
			'Authorization': `Bearer ${token}`
		});
		return this.http.put(`${url}/${id}`, RequestModel, { headers: headers, observe: 'response' }).pipe(
			catchError(this.handleError)
		);
	}

	public wsPutById(url: string, id: any): Observable<any> {
		let token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : '';
		let headers = new HttpHeaders({
			'Content-Type': 'application/json; charset=utf-8',
			'Authorization': `Bearer ${token}`
		});
		return this.http.put(`${url}/${id}`, null, { headers: headers, observe: 'response' }).pipe(
			catchError(this.handleError)
		);
	}

	public wsGet(url: string): Observable<any> {
		let token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : '';
		let headerss = new HttpHeaders({
		  'Content-Type': 'application/json; charset=utf-8',
		  'Authorization': `Bearer ${token}`
		});
		return this.http.get(url, { headers: headerss, observe: 'response' }).pipe(
		  catchError(this.handleError)
		);
	  }

	public wsPostFile(RequestModel: any, url: string): Observable<any> {
		let token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : '';
		let headers = new HttpHeaders({
			'Authorization': `Bearer ${token}`
		});
		return this.http.post(url, RequestModel, { headers: headers, observe: 'response' }).pipe(
			catchError(this.handleError)
		);
	}

	public wsPatch(RequestModel: any, url: string, id: any): Observable<any> {
		let token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : '';
		let headers = new HttpHeaders({
			'Content-Type': 'application/json; charset=utf-8',
			'Authorization': `Bearer ${token}`
		});
		return this.http.patch(`${url}/${id}`, RequestModel, { headers: headers, observe: 'response' }).pipe(
			catchError(this.handleError)
		);
	}

	public wsPutByUrl(url: string, file: File): Observable<any> {
		let token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : '';
		let headers = new HttpHeaders({
			'Content-Type':  file.type,
		});
		return this.http.put(`${url}`, file, { headers: headers, observe: 'response' }).pipe(
			catchError(this.handleError)
		);
	}	

	handleError(Error: any) {
		let errorMessage = '';
		if (Error.error instanceof ErrorEvent) {
		  // Get client-side error
		  errorMessage = Error.error.message;
	
		} else {
		  // Get server-side error
		  errorMessage = `Error Code: ${Error.status}\nMessage: ${Error.message}`;
		  if (Error.status == 403) {
			sessionStorage.clear();
			window.location.reload();
		  }
		}
		return throwError(Error.error.responseMessage || Error);
	  }

	show() {
		this.isLoading.next(true);
	}

	hide() {
		this.isLoading.next(false);
	}

}
